import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { ToastElement, ToastType } from '../common/components/toast/model/toast-element';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toastAdded: Subject<ToastElement> = new Subject<ToastElement>();
  toastAddedObservable$: Observable<ToastElement> = this.toastAdded.asObservable();
  constructor() { }

  showToast(message: string, type: ToastType) {
    this.toastAdded.next({textKey: message, type: type});
  }

  showInfoToast(messageTranslationKey: string) {
    this.showToast(messageTranslationKey, 'info');
  }

  /**
   * t(toast.success)
   */
  showSuccessToast(messageTranslationKey: string = 'toast.success') {
    this.showToast(messageTranslationKey, 'success');
  }
  showWarningToast(messageTranslationKey: string) {
    this.showToast(messageTranslationKey, 'warning');
  }

  showErrorToast(messageTranslationKey: string = 'error.general') {
    this.showToast(messageTranslationKey, 'error');
  }
}
